import enUs from "./en-us";
import nlNl from "./nl-nl";
import frFr from "./fr-fr";
import deDe from "./de-de";
export default {
  'en-us': enUs,
  'nl-nl': nlNl,
  'fr-fr': frFr,
  'de-de': deDe
};